import React, { useEffect } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import BlogCard from "../components/BlogCard";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs } from "../features/blogs/blogSlice";
import moment from "moment";

const Blog = () => {
  const blogState = useSelector((state) => state?.blog?.blog);

  const dispatch = useDispatch();
  useEffect(() => {
    getblogs();
  }, []);
  const getblogs = () => {
    dispatch(getAllBlogs());
  };

  // Schema markup for structured data
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "VEDA Blog - Mythological Stories and Educational Content",
    "description": "Explore our collection of blog posts about Indian mythology, educational content, and mythological toys.",
    "url": "https://vedamerchandise.com/blogs",
    "publisher": {
      "@type": "Organization",
      "name": "VEDA Merchandise",
      "logo": {
        "@type": "ImageObject",
        "url": "https://vedamerchandise.com/logo.svg"
      }
    }
  };

  return (
    <>
      <Meta 
        title="VEDA Blog - Mythological Stories and Educational Content"
        description="Explore our collection of blog posts about Indian mythology, educational content, and mythological toys."
        keywords="mythology blog, Indian mythology, educational content, mythological stories, VEDA blog"
        author="VEDA Merchandise"
        ogTitle="VEDA Blog - Mythological Stories and Educational Content"
        ogDescription="Explore our collection of blog posts about Indian mythology, educational content, and mythological toys."
        ogImage="https://vedamerchandise.com/blog-preview.jpg"
        ogUrl="https://vedamerchandise.com/blogs"
        ogType="website"
        twitterCard="summary_large_image"
        twitterTitle="VEDA Blog - Mythological Stories and Educational Content"
        twitterDescription="Explore our collection of blog posts about Indian mythology, educational content, and mythological toys."
        twitterImage="https://vedamerchandise.com/blog-preview.jpg"
        robots="index, follow"
        canonicalUrl="https://vedamerchandise.com/blogs"
        schemaMarkup={schemaMarkup}
      />
      <Container class1="blog-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-3">
            <div className="filter-card mb-3">
              <h3 className="filter-title">Find By Categories</h3>
              <div>
                <ul className="ps-0">
                  <li>Watch</li>
                  <li>Tv</li>
                  <li>Camera</li>
                  <li>Laptop</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-9">
            <div className="row">
              {blogState &&
                blogState?.map((item, index) => {
                  return (
                    <div className="col-6 mb-3" key={index}>
                      <BlogCard
                        id={item?._id}
                        title={item?.title}
                        description={item?.description}
                        image={item?.images[0]?.url}
                        date={moment(item?.createdAt).format(
                          "MMMM Do YYYY, h:mm a"
                        )}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Blog;